var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[_c('textarea',{attrs:{"placeholder":_vm.contents.placeholder}}),_c('span',[_vm._v(_vm._s(_vm.contents.label)+" é obrigatório")])])
}
var staticRenderFns = []

export { render, staticRenderFns }